import commentLoad from '../libraries/ai-call-contract-comment-load'

export default (store_ai_call_contract_id, store_ai_call_contract_workflow_id, token) => {
  let url = '/api/v1/store_ai_call_contract_comments/'
  let id = store_ai_call_contract_id
  if(id === '') {
    id = store_ai_call_contract_workflow_id
    url = '/api/v1/store_ai_call_contract_workflow_comments/'
  }

  Array.from(document.getElementsByClassName('comment-submit')).forEach(el => {
    el.addEventListener('click', (e) => {
      Array.from(document.getElementsByClassName('comment-input')).forEach(comment =>{
        if (comment.value.length == 0) return

        const data = {
          ai_call_comment: {
            comment: comment.value,
            store_ai_call_contract_id: store_ai_call_contract_id,
            store_ai_call_contract_workflow_id: store_ai_call_contract_workflow_id
          }
        }

        const xhr = new XMLHttpRequest()
        xhr.open('POST', url + id)
        xhr.setRequestHeader('X-CSRF-Token', token)
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(data))
        xhr.addEventListener('load', function(result) {
          if (result.currentTarget.status == 204) {
            comment.value = ''
            commentLoad(store_ai_call_contract_id, store_ai_call_contract_workflow_id, token, 30)
          } else if (result.currentTarget.responseText.length > 0) {
            alert(result.currentTarget.responseText)
          }
        })
      })
    })
  })

}
